import { styled, TableCell } from '@mui/material';

type TableHeaderCellProps = {
  coltype: 'label' | 'plan1' | 'plan2' | 'plan3';
};

export const TableHeaderCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'coltype'
})<TableHeaderCellProps>(({ theme, coltype }) => {
  let width: string;

  if (coltype === 'label') {
    width = '15%';
  } else {
    width = '10%';
  }

  return {
    backgroundColor: '#f8423d',
    border: `1px solid black`,
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '12px',
    color: theme.palette.common.white,
    width,

    '& .description': {
      fontSize: '14px',
      fontWeight: 500,
      display: 'block',
      color: theme.palette.common.white
    },

    [theme.breakpoints.down('sm')]: {
      width: coltype === 'label' ? '35%' : '21%',
      padding: '12px 4px',
      fontSize: '12px',

      '& .description': {
        fontSize: '11px'
      }
    }
  };
});

export const TableBodyCell = styled(TableCell)<{
  highlight: boolean;
  strong: boolean;
}>(({ theme, highlight, strong }) => ({
  backgroundColor: highlight ? '#facccd' : theme.palette.common.white,
  fontWeight: (highlight || strong) && 700,
  border: `1px solid black`,
  padding: '20px',
  color: strong ? '#f8423d' : theme.palette.common.black,
  whiteSpace: 'pre-line',

  [theme.breakpoints.down('sm')]: {
    padding: '15px 4px',
    fontSize: '12px'
  }
}));
